module.exports = __webpack_public_path__ + "static/media/minion-working.413a8a08.png";